"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function replaceFragment(replacer, fragment, key) {
    var regexp = replacer.regexp, replace = replacer.replace;
    if (!regexp.global) {
        throw new Error("regular expression must be a global match");
    }
    var elements = [];
    var lastIndex = 0;
    regexp.lastIndex = lastIndex;
    var match = regexp.exec(fragment);
    if (match == null) {
        return fragment;
    }
    do {
        var index = match.index;
        var text = match[0];
        // Push preceding text if any.
        if (index > lastIndex) {
            elements.push(fragment.substring(lastIndex, index));
        }
        // Append link to result.
        elements.push(replace.apply(void 0, [key + ":" + index].concat(match)));
        // Update last index.
        lastIndex = index + text.length;
        // Run match again.
        match = regexp.exec(fragment);
    } while (match != null);
    // Push remaining text if any.
    if (lastIndex < fragment.length) {
        elements.push(fragment.substring(lastIndex));
    }
    return elements;
}
function replaceFragments(replacer, fragments, key) {
    return fragments.reduce(function (memo, fragment, index) {
        return memo.concat(typeof fragment === "string"
            ? replaceFragment(replacer, fragment, key + ":" + index)
            : fragment);
    }, []);
}
function replaceAny(replacers, str) {
    return replacers.reduce(function (memo, replacer, index) {
        return replaceFragments(replacer, memo, "" + index);
    }, [str]);
}
exports.replaceAny = replaceAny;
